import type { RefObject } from 'react';

import React, { createContext, useContext } from 'react';

interface ScrollTargetCtx {
  ref?: RefObject<HTMLElement | null>;
}

const ScrollTargetContext = createContext<ScrollTargetCtx>({});

export const useScrollTarget = () => useContext(ScrollTargetContext);

/**
 * Wrap parts of the app that should use a custom scroll container.
 * Pass `scrollRef` for the container you want ScrollTop to control.
 */
export function ScrollTargetProvider({
  scrollRef,
  children,
}: {
  scrollRef?: RefObject<HTMLElement | null>;
  children: React.ReactNode;
}) {
  return <ScrollTargetContext.Provider value={{ ref: scrollRef }}>{children}</ScrollTargetContext.Provider>;
}
